"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTradeClientV1 = exports.getTradeClientV0 = exports.revertToTradeV1 = exports.revertToTradeV0 = exports.convertTradesV1 = exports.convertTradesV0 = void 0;
const escrow_sdk_v0_1 = require("escrow-sdk-v0");
const index_1 = require("../../index");
const types_1 = require("../types");
const consts_1 = require("./consts");
const anchor_1 = require("@project-serum/anchor");
const common_sdk_1 = require("@orca-so/common-sdk");
const decimal_js_1 = __importDefault(require("decimal.js"));
const convertTradesV0 = (trades) => {
    return trades
        .map((trade) => {
        if (!trade)
            return null;
        // The spread operator is used to copy properties from trade.
        // Additional properties are set to comply with the ITradeDataInfo type.
        return Object.assign(Object.assign({}, trade), { sellOfferId: trade.offerId, buyOfferId: new anchor_1.BN(0), marketAccount: consts_1.NULL_PUBKEY, configAccount: trade.escrowConfig, tradeAmount: trade.tokenAmount, bankName: null, accountNumber: null, accountName: null, nonce: null, useBondless: false, version: types_1.Version.V0, bondAmountSpl: trade.bondAmount, bondAmountNative: trade.bondAmount, sellerBondAmountSpl: new anchor_1.BN(0), sellerBondAmountNative: new anchor_1.BN(0), sellerBondType: trade.bondType, buyerBondType: trade.bondType, fiatCurrency: "", fiatAmount: common_sdk_1.DecimalUtil.fromU64(trade.fiatAmount, index_1.SCALE_EXPO).toNumber() });
    })
        .filter((trade) => trade !== null);
};
exports.convertTradesV0 = convertTradesV0;
const convertTradesV1 = (trades) => {
    return trades.map((trade) => {
        return Object.assign(Object.assign({}, trade), { tokenVault: consts_1.NULL_PUBKEY, nativeVault: consts_1.NULL_PUBKEY, version: types_1.Version.V1 });
    });
};
exports.convertTradesV1 = convertTradesV1;
const revertToTradeV0 = (trade) => {
    const { marketAccount, bankName, accountName, accountNumber, nonce, configAccount, version, tradeAmount, useBondless, sellerBondType, buyerBondType, bondAmountNative, bondAmountSpl } = trade, rest = __rest(trade, ["marketAccount", "bankName", "accountName", "accountNumber", "nonce", "configAccount", "version", "tradeAmount", "useBondless", "sellerBondType", "buyerBondType", "bondAmountNative", "bondAmountSpl"]);
    return Object.assign(Object.assign({}, rest), { offerId: trade.sellOfferId, tokenAmount: tradeAmount, escrowConfig: configAccount, configRentVault: consts_1.NULL_PUBKEY, bondAmount: bondAmountSpl, bondType: sellerBondType, fiatAmount: common_sdk_1.DecimalUtil.toU64(new decimal_js_1.default(rest.fiatAmount), index_1.SCALE_EXPO) });
};
exports.revertToTradeV0 = revertToTradeV0;
const revertToTradeV1 = (trade) => {
    const { version, tokenVault, nativeVault } = trade, rest = __rest(trade, ["version", "tokenVault", "nativeVault"]);
    return Object.assign(Object.assign({}, rest), { fiatAmount: common_sdk_1.DecimalUtil.toU64(new decimal_js_1.default(rest.fiatAmount), index_1.SCALE_EXPO) });
};
exports.revertToTradeV1 = revertToTradeV1;
const getTradeClientV0 = (ctx, configId, tradeData) => {
    const pda = new escrow_sdk_v0_1.PDA(ctx.program.programId, configId);
    const tradePubkey = pda.getTradePDA(tradeData.tradeId).key;
    return new escrow_sdk_v0_1.TradeClient(ctx, tradePubkey, (0, exports.revertToTradeV0)(tradeData), pda, configId);
};
exports.getTradeClientV0 = getTradeClientV0;
const getTradeClientV1 = (ctx, marketId, configId, tradeData) => {
    const pda = new index_1.PDA(ctx.program.programId, marketId, configId);
    const tradePubkey = pda.getTradePDA(tradeData.tradeId).key;
    return new index_1.TradeClient(ctx, tradePubkey, (0, exports.revertToTradeV1)(tradeData), pda, configId);
};
exports.getTradeClientV1 = getTradeClientV1;
